/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { ExportLogEntryStatus } from '../enums/export-log-entry-status.enum';
import { CpcDocumentMessageType } from '../enums/cpc-document-message-type.enum';

//<custom-head>
import { ExportCaseCorrectionDocumentAction } from 'api/enums';
//</custom-head>

export class ClearanceCaseCustomsDocumentDto {
  public id: string = undefined;
  public currentStatus: ExportLogEntryStatus;
  public customsId: string = undefined;
  public messageType: CpcDocumentMessageType;
  public declarationCode: string = undefined;
  public customsSequenceNumber: string = undefined;
  public mrn: string = undefined;
  public xML: string = undefined;
  public errors: string = undefined;
  public sentToCustomerUtc: Date | string;

  //<custom-body>
  public action: ExportCaseCorrectionDocumentAction;

  constructor(source: ClearanceCaseCustomsDocumentDto) {
    Object.assign(this, source);
    this.xML = source.xML || (source as any).xml
    this.action = this.getDefaultAction;
  }

  private get getDefaultAction(){
    if(!this.customsId){
      return ExportCaseCorrectionDocumentAction.Ignore;
    }

    switch (+this.currentStatus) {
      case ExportLogEntryStatus.CustomsAccepted:
      case ExportLogEntryStatus.CustomsReleased:
        return ExportCaseCorrectionDocumentAction.Ignore;
      default:
        return ExportCaseCorrectionDocumentAction.Reuse;
    }
  }

  get hasErrorStatus(): boolean {
    switch (+this.currentStatus) {
      case ExportLogEntryStatus.CustomsRejected:
      case ExportLogEntryStatus.Failed:
      case ExportLogEntryStatus.Stuck:
        return true;
      default:
        return false;
    }
  }

  get isNo(){
    return this.messageType === CpcDocumentMessageType.NoExp || this.messageType === CpcDocumentMessageType.NoImp;
  }

  get isSe(){
    return this.messageType === CpcDocumentMessageType.SeExp || this.messageType === CpcDocumentMessageType.SeImp;
  }
  //</custom-body>
}
